
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_ON_SITE(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.FUSION, name: name, contents: [] };

  cat.contents = [
    BH.label("On-Site Bot Funktionen"),

    BH.withNested(
      BH._custom("PARENT_EXEC", "Eltern Seite (Code ausführen): {{code}}", "RAGAI.PARENT.exec({{code}});"),
      [
        { forValue: "code", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
    BH.withNested(
      BH._custom("PARENT_get", "@output:String\n  Eltern Seite (Wert Holen) {{code}}", "await RAGAI.PARENT.get({{code}})"),
      [
        { forValue: "code", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
    BH._custom("PARENT_GET_TEXT", "@output:String\n  Eltern Seite (Seiten Inhalt)  ", "await RAGAI.MSG.botMessage(await RAGAI.PARENT.get(\"window.document.body.innerText\"));"),


    BH.withNested(
      BH._custom("PARENT_NAVIGATE_TO", "Eltern Seite (Navigiere)  {{url[@check=URL]}} ", 'await RAGAI.PARENT.exec(\'window.location.href={{url}}\');'),
      [
        { forValue: "url", isShadow: true, targetBlockType: BLOCKLY_DUMMY.URL }
      ]
    ),



    BH._custom("PARENT_OPEN_BOT", "On-Site-Bot öffnen ", 'await RAGAI.PARENT.exec(\'window.RAGBOT.openChatbot()\');'),
    BH._custom("PARENT_CLOSE_BOT", "On-Site-Bot schließen ", 'await RAGAI.PARENT.exec(\'window.RAGBOT.closeChatbot()\');'),
    BH._custom("PARENT_RECREATE_BOT_STATE", " On-Site-Bot (open/close) Zustand wiederherstellen", 'await RAGAI.PARENT.exec(\'window.RAGBOT.recreateOpenState()\');'),
    BH.label("URL-Funktionen"),
    BH._custom("PARENT_LOCATION_X", "@output:String\n Eltern Seite: window.location.{{action:dropdown=href,hash,search}} ", 'await RAGAI.PARENT.get(\'window.location.{{action}}\')'),
    BH.withNested(
      BH._custom("PARENT_PARAM_BY_BAME", "@output:String\n Eltern Seite: URL Parameter {{pname}} ", 'await RAGAI.PARENT.exec(\'new URLSearchParams(window.location.search).get({{pname}})\')'),
      [
        { forValue: "pname", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    )


  ];



  return cat;
}
